import { useEffect, useState } from 'react';
// import copy from 'copy-to-clipboard';
import { generatePath, NavLink } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import {
  OnSelectChange,
  SelectSize,
  InputText,
  InputSize,
  Checkbox,
  Select,
  // IconLink,
  IconUp,
  IconDown,
  ButtonSecondary,
  ButtonSize,
  IconSelected,
  IconBack,
  PermissionEnum,
  IconChangeLoClock,
} from '@ui/src';
import { useAppSelector } from '@store';
import {
  AccessRight,
  CofApprovalStatus,
  NatureOfControlEnum,
  NewApplicationChildrenInfo,
  NewApplicationListItem,
  NewApplicationStatus,
  ReviewStatus,
  SignatureType,
} from '../../../hoc/new-application/types';
import InfoRow from '../info-row';
import {
  useUpdateAppToAppMutation,
  useUpdateAppToAppStatusMutation,
  useUpdateCorporateQuestionnarieMutation,
} from '../../../hoc/new-application/store/services';
import getStatusClassName from '../../../hoc/new-application/helpers/get-status-class-name';
import getCorporateAppicationBody from '../../../hoc/new-application/corporate/helpers/get-corporate-application-body';
import getCorporateQuestionnarieBody from '../../../hoc/new-application/corporate/helpers/get-questionnarie-body';
import { CorporateQuestionnarieFormValues } from '../../../hoc/customers/types';
import { ApplicationCOFTypes } from '../types';

import ROUTES from '../../../routes';

import cn from '../new-application.module.css';

const CompanyOfficial = ({
  value,
  setValue,
  setValuesList,
  index,
  values,
  applicationId,
  companyOfficial,
  disabled,
  type,
  applicationStatus,
  initialFields,
  fields,
  onApplicationSubmit,
  approveDisabled,
  questionnarieFields,
  defaultQuestionnarieFormValues,
  applicationScheme,
  auditLogAvailable,
  getApplicationChat,
  onSaveAccountsCurrencies,
  onSaveAccountsFlows,
  onSaveExpectedFundsOrigins,
}: ApplicationCOFTypes) => {
  const [collapsed, setCollapsed] = useState(true);
  const [update, { isLoading: updateInProgress, isError }] =
    useUpdateAppToAppMutation();
  const [updateStatus, { isLoading: updateStatusInProgress }] =
    useUpdateAppToAppStatusMutation();
  const [companyOfficialPosition, setCompanyOfficialPosition] = useState('');
  const [companyOfficialSignatureType, setCompanyOfficialSignatureType] =
    useState('');
  const [companyOfficialPercentage, setCompanyOfficialPercentage] =
    useState('');
  const [companyOfficialNatureOfControl, setCompanyOfficialNatureOfControl] =
    useState('');
  const [companyOfficialAccessRight, setCompanyOfficialAccessRight] = useState(
    AccessRight.NONE,
  );
  const [error, setError] = useState('');
  const [havingControl, setHavingControl] = useState(false);
  const [focused, setFocused] = useState(false);
  const [defaultValues, setDefaultValues] = useState<any>({});
  const [cofUpdateInProgress, setCofUpdateInProgress] = useState(false);

  const [updateCorporateQuestionnarie] =
    useUpdateCorporateQuestionnarieMutation();

  // const [copyEffect, setCopyEffect] = useState(false);

  const { activePermissions } = useAppSelector(
    (state) => state.customersDictionaries,
  );

  // const onCopy = useCallback(() => {
  //   copy(
  //     `${window.location.origin}${generatePath(ROUTES.SUMSUB, {
  //       applicationId: companyOfficial?.subApplication.id as string,
  //     })}?phone=${companyOfficial?.subApplication.phone}${
  //       companyOfficial?.subApplication.email
  //         ? `&email=${companyOfficial?.subApplication.email}`
  //         : ''
  //     }`,
  //   );
  //   setCopyEffect(true);

  //   setTimeout(() => {
  //     setCopyEffect(false);
  //   }, 2000);
  // }, [window.location]);

  const onChange = (
    e: React.ChangeEvent<HTMLInputElement> | OnSelectChange,
  ) => {
    const nextValues = values.map((item, valueIndex) => {
      const result = { ...item };

      if (index === valueIndex) {
        if (e.target.name === `customerId-${index}`) {
          result.id = e.target.value as string;
        } else if (e.target.name === `percentage-${index}`) {
          result.percentage = e.target.value as string;
          setCompanyOfficialPercentage(e.target.value as string);
        } else if (e.target.name === `natureOfControl-${index}`) {
          result.natureOfControl = e.target.value as string;
          setCompanyOfficialNatureOfControl(e.target.value as string);
        } else if (e.target.name === `signatureType-${index}`) {
          result.signatureType = e.target.value as string;
          setCompanyOfficialSignatureType(e.target.value as string);
        } else if (e.target.name === `accessRight-${index}`) {
          result.accessRight = e.target.value as AccessRight;
          setCompanyOfficialAccessRight(e.target.value as AccessRight);
        } else {
          result.position = e.target.value as string;
          setCompanyOfficialPosition(e.target.value as string);
        }
      }

      return result;
    });

    setValue('companyOfficial', nextValues as NewApplicationChildrenInfo[]);
    setValuesList(nextValues);
  };

  useEffect(() => {
    if (companyOfficialPosition && !value.position) {
      const nextValues = values.map((item, valueIndex) => {
        const result = { ...item };

        if (index === valueIndex) {
          result.position = companyOfficialPosition;
        }

        return result;
      });

      setValue('companyOfficial', nextValues as NewApplicationChildrenInfo[]);
      setValuesList(nextValues);
    }
  }, [companyOfficialPosition, value, index]);

  const onUpdate = async () => {
    setError('');

    const body: {
      percentage?: string;
      natureOfControl?: string;
      position?: string;
      signatureType?: string;
      accessRight: AccessRight;
    } = {
      accessRight: companyOfficialAccessRight,
    };

    if (companyOfficialPosition) {
      body.position = companyOfficialPosition;
    }

    if (companyOfficialPercentage) {
      body.percentage = companyOfficialPercentage;
    }

    if (companyOfficialNatureOfControl) {
      body.natureOfControl = companyOfficialNatureOfControl;
    }

    if (companyOfficialSignatureType) {
      body.signatureType = companyOfficialSignatureType;
    }

    let response;

    const nextFields = { ...fields };

    if (companyOfficial?.status !== CofApprovalStatus.DECLINED) {
      response = (await update({
        id: applicationId as string,
        appToAppId: companyOfficial?.id as string,
        body,
      })) as {
        data?: { data: NewApplicationListItem };
        error?: { data: { message: string } };
      };

      delete nextFields?.mainRepresentative;
      delete nextFields?.companyOfficial;

      if (response?.error?.data?.message) {
        setError(response.error.data.message);
      }
    }

    if (!isEqual(nextFields, initialFields)) {
      const applictionBody = getCorporateAppicationBody(nextFields);

      if (!applictionBody.websiteLink) {
        applictionBody.websiteLink = '';
      }

      onApplicationSubmit({
        body: applictionBody,
        id: applicationId as string,
      });
    }

    if (!isEqual(questionnarieFields, defaultQuestionnarieFormValues)) {
      if (
        applicationScheme &&
        (applicationScheme?.accountantDetailsActive ||
          applicationScheme?.auditedByExternalComplianceActive ||
          applicationScheme?.changesInManagementOrOwnershipActive ||
          applicationScheme?.complianceConsultantDetailsActive ||
          applicationScheme?.fcaNumberActive ||
          applicationScheme?.hmrcMlrNumberActive ||
          applicationScheme?.hmrcRegistrationExpiryDateActive ||
          applicationScheme?.icoNumberActive ||
          applicationScheme?.itProviderDetailsActive ||
          applicationScheme?.mlroDetailsActive ||
          applicationScheme?.numberOfAgentsActive ||
          applicationScheme?.numberOfBranchesActive ||
          applicationScheme?.onboardCorporateClientsActive ||
          applicationScheme?.onboardMsbActive ||
          applicationScheme?.paymentsForCharitiesActive ||
          applicationScheme?.payoutPartnerDetailsActive ||
          applicationScheme?.regulatoryInvestigationActive ||
          applicationScheme?.screeningActive ||
          applicationScheme?.transactionMonitoringActive ||
          applicationScheme?.typeOfBusinessLicenceActive ||
          applicationScheme?.visitedByAuthoritiesActive ||
          applicationScheme?.workingWithAnyOtherIPSPActive ||
          applicationScheme?.id === 'cdbb8c71-90e6-4a5e-964f-e55169e0c4df')
      ) {
        const questionnarieBody = getCorporateQuestionnarieBody({
          questionnarieValues:
            questionnarieFields as CorporateQuestionnarieFormValues,
          scheme: applicationScheme,
        });

        updateCorporateQuestionnarie({
          id: applicationId as string,
          body: questionnarieBody,
        });

        if (applicationScheme?.id === 'cdbb8c71-90e6-4a5e-964f-e55169e0c4df') {
          onSaveAccountsCurrencies();
          onSaveAccountsFlows();
          onSaveExpectedFundsOrigins();
        }
      }
    }

    return response;
  };

  const onUpdateStatus = async (status: CofApprovalStatus) => {
    let statusUpdateAllowed = true;

    if (
      !isEqual(defaultValues, {
        position: companyOfficialPosition,
        percentage: companyOfficialPercentage,
        natureOfControl: companyOfficialNatureOfControl,
        signatureType: companyOfficialSignatureType,
        accessRight: companyOfficialAccessRight,
      })
    ) {
      setCofUpdateInProgress(true);
      statusUpdateAllowed = false;

      const response = await onUpdate();

      if (response) {
        statusUpdateAllowed = true;

        setCofUpdateInProgress(false);
      } else if (companyOfficial?.status === CofApprovalStatus.DECLINED) {
        statusUpdateAllowed = true;

        setCofUpdateInProgress(false);
      }
    }

    if (statusUpdateAllowed) {
      const response = (await updateStatus({
        id: applicationId as string,
        appToAppId: companyOfficial?.id as string,
        body: {
          status,
        },
      })) as {
        error?: { data: { message: string } };
      };

      if (response?.error?.data?.message) {
        setError(response.error.data.message);
      } else if (
        !response.error &&
        (status === CofApprovalStatus.ACCEPTED ||
          status === CofApprovalStatus.DECLINED) &&
        getApplicationChat
      ) {
        getApplicationChat(applicationId as string);
      }
    }
  };

  const { statusClassName } = getStatusClassName({
    status: companyOfficial?.subApplication.status as NewApplicationStatus,
  });

  let cofApprovalStatus = 'Awaiting Approval';
  let cofApprovalStatusClassName = cn.incompleteStatus;
  let cofApplicationDescription = 'Application is incomplete';
  let cofApplicationStatus = 'Incomplete';
  let cofApprovalButton;

  if (
    companyOfficial?.status !== CofApprovalStatus.ACCEPTED &&
    companyOfficial?.status !== CofApprovalStatus.DECLINED &&
    companyOfficial?.subApplication.status === NewApplicationStatus.ACCEPTED
  ) {
    let buttonText;

    if (updateStatusInProgress || cofUpdateInProgress) {
      buttonText = 'Loading...';
    } else if (!updateStatusInProgress && type === 'MR') {
      buttonText = 'Approve as Main Representative';
    } else if (!updateStatusInProgress && type === 'COF') {
      buttonText = 'Approve as Company Official';
    }

    cofApprovalButton = (
      <ButtonSecondary
        className={`${cn.cofApproveButton} ${
          !value.position ||
          !value.signatureType ||
          (type === 'MR' && approveDisabled)
            ? cn.cofApproveButtonDisabled
            : ''
        }`}
        size={ButtonSize.SMALL}
        icon={!updateStatusInProgress ? <IconSelected /> : undefined}
        text={buttonText}
        disabled={
          !value.position ||
          !value.signatureType ||
          (type === 'MR' && approveDisabled)
        }
        onClick={() => onUpdateStatus(CofApprovalStatus.ACCEPTED)}
        tabIndex={-1}
      />
    );
  } else if (companyOfficial?.status === CofApprovalStatus.ACCEPTED) {
    cofApprovalButton = (
      <ButtonSecondary
        className={cn.cofApproveButton}
        size={ButtonSize.SMALL}
        icon={
          !updateStatusInProgress ? (
            <IconBack className={cn.backIcon} />
          ) : undefined
        }
        text={
          updateStatusInProgress || cofUpdateInProgress
            ? 'Loading...'
            : 'Cancel approval'
        }
        tabIndex={-1}
        onClick={() => onUpdateStatus(CofApprovalStatus.INPROCESS)}
      />
    );
  } else if (companyOfficial?.status === CofApprovalStatus.DECLINED) {
    cofApprovalButton = (
      <ButtonSecondary
        className={cn.cofApproveButton}
        size={ButtonSize.SMALL}
        icon={
          !updateStatusInProgress ? (
            <IconBack className={cn.backIcon} />
          ) : undefined
        }
        tabIndex={-1}
        text={
          updateStatusInProgress || cofUpdateInProgress
            ? 'Loading...'
            : 'Cancel Decline'
        }
        onClick={() => onUpdateStatus(CofApprovalStatus.INPROCESS)}
      />
    );
  }

  if (companyOfficial?.status === CofApprovalStatus.ACCEPTED) {
    cofApprovalStatus = 'Accepted';
    cofApprovalStatusClassName = cn.acceptedStatus;
  } else if (companyOfficial?.status === CofApprovalStatus.DECLINED) {
    cofApprovalStatus = 'Declined';
    cofApprovalStatusClassName = cn.declinedStatus;
  } else if (
    companyOfficial?.subApplication.status === NewApplicationStatus.DECLINED
  ) {
    cofApprovalStatusClassName = cn.declinedStatus;

    if (type === 'MR') {
      cofApprovalStatus = 'Customer can`t be approval as Main Representative';
    } else {
      cofApprovalStatus = 'Customer can`t be approval as Company Official';
    }
  }

  if (
    companyOfficial?.subApplication.status === NewApplicationStatus.DECLINED
  ) {
    cofApplicationDescription = 'Application declined';
  }

  if (
    companyOfficial?.subApplication.reviewStatus ===
      ReviewStatus.HAS_DUPLICATE &&
    companyOfficial?.subApplication.status !== NewApplicationStatus.DECLINED
  ) {
    cofApplicationDescription = 'Application in warning';
  }

  if (
    companyOfficial?.subApplication.reviewStatus ===
      ReviewStatus.HAS_DUPLICATE &&
    companyOfficial.subApplication.status !== NewApplicationStatus.DECLINED
  ) {
    cofApplicationStatus = 'Warning';
  } else if (companyOfficial && companyOfficial.subApplication.status) {
    cofApplicationStatus = `${companyOfficial.subApplication.status.charAt(
      0,
    )}${companyOfficial.subApplication.status
      .slice(1)
      .toLowerCase()
      .split('_')
      .join(' ')}`;
  }

  let cofLink;

  if (
    companyOfficial &&
    companyOfficial?.subApplication.status !== NewApplicationStatus.ACCEPTED
  ) {
    if (companyOfficial?.subApplication.type === 'INDIVIDUAL') {
      cofLink = generatePath(ROUTES.CUSTOMERS_NEW_APPLICATION_INDIVIDUAL_INFO, {
        applicationId: companyOfficial?.subApplication.id,
      });
    } else {
      cofLink = generatePath(
        ROUTES.CUSTOMERS_NEW_APPLICATION_COMPANY_OFFICIAL,
        {
          applicationId: companyOfficial?.subApplication.id,
        },
      );
    }
  } else if (
    companyOfficial &&
    companyOfficial?.subApplication.status === NewApplicationStatus.ACCEPTED &&
    companyOfficial.subApplication.organizationId
  ) {
    cofLink = generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_PAGE, {
      customerId: companyOfficial?.subApplication.organizationId,
    });
  }

  useEffect(() => {
    if (value.percentage || value.natureOfControl) {
      setHavingControl(true);
    }
  }, [value]);

  useEffect(() => {
    if (companyOfficial) {
      if (companyOfficial.position) {
        setCompanyOfficialPosition(companyOfficial.position);
      }

      if (companyOfficial?.natureOfControl) {
        setCompanyOfficialNatureOfControl(companyOfficial.natureOfControl);
      }

      if (companyOfficial?.percentage) {
        setCompanyOfficialPercentage(companyOfficial.percentage);
      }

      if (companyOfficial?.signatureType) {
        setCompanyOfficialSignatureType(companyOfficial.signatureType);
      }

      if (companyOfficial?.accessRight) {
        setCompanyOfficialAccessRight(companyOfficial.accessRight);
      }

      setDefaultValues({
        position: companyOfficial.position,
        percentage: companyOfficial.percentage || '',
        natureOfControl: companyOfficial.natureOfControl || '',
        signatureType: companyOfficial.signatureType || '',
        accessRight: companyOfficial.accessRight || AccessRight.NONE,
      });
    }
  }, [companyOfficial]);

  useEffect(() => {
    if (isError) {
      setCompanyOfficialNatureOfControl(defaultValues.natureOfControl);
      setCompanyOfficialPercentage(defaultValues.percentage);
      setCompanyOfficialPosition(defaultValues.position);
      setCompanyOfficialSignatureType(defaultValues.signatureType);
      setCompanyOfficialAccessRight(defaultValues.accessRight);
    }
  }, [isError]);

  useEffect(() => {
    if (
      companyOfficialPercentage &&
      !/^\d*\.?\d*$/.test(companyOfficialPercentage)
    ) {
      setError('Percentage of control field must be numeric');
    } else {
      setError('');
    }
  }, [companyOfficialPercentage]);

  return (
    <div className={cn.mainRepresentativeApplicationsWrapper}>
      {companyOfficial && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <div
          onClick={() => !focused && setCollapsed(!collapsed)}
          className={`${cn.mainRepresentativeApplication} ${
            collapsed ? cn.mainRepresentativeApplicationCollapsed : ''
          }`}
        >
          <div className={cn.mainRepresentativeApplicationLeft}>
            <div className={cn.collapsedArrow}>
              {collapsed ? <IconUp /> : <IconDown />}
            </div>
            <div className={cn.mainRepresentativeName}>{`${
              companyOfficial.subApplication.firstName || '-'
            } ${companyOfficial.subApplication.lastName || '-'}`}</div>
            <div
              className={`${cn.applicationStatus} ${cn.mainRepresentativeApplicationStatus} ${cofApprovalStatusClassName}`}
            >
              {cofApprovalStatus}
            </div>
          </div>
          {applicationStatus !== NewApplicationStatus.ACCEPTED &&
            applicationStatus !== NewApplicationStatus.DECLINED && (
              <div className={cn.mainRepresentativeApplicationRight}>
                {companyOfficial.subApplication.status !==
                  NewApplicationStatus.ACCEPTED && (
                  <div className={cn.cofApplicationDescription}>
                    {cofApplicationDescription}
                  </div>
                )}

                <div
                  className={cn.cofApproveControls}
                  onMouseEnter={() => setFocused(true)}
                  onMouseLeave={() => setFocused(false)}
                >
                  {activePermissions?.includes(
                    PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                  ) &&
                    companyOfficial.subApplication.status !==
                      NewApplicationStatus.DECLINED && (
                      <div className={cn.cofApproveButtonWrapper}>
                        {cofApprovalButton}
                      </div>
                    )}
                  {activePermissions?.includes(
                    PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                  ) &&
                    (companyOfficial.status !== CofApprovalStatus.DECLINED ||
                      (companyOfficial.subApplication.status ===
                        NewApplicationStatus.DECLINED &&
                        companyOfficial.status !==
                          CofApprovalStatus.DECLINED)) && (
                      <div className={cn.cofApproveButtonWrapper}>
                        <ButtonSecondary
                          className={`${cn.cofApproveButton} ${cn.cofApprovalButtonWarning}`}
                          size={ButtonSize.SMALL}
                          text={
                            updateStatusInProgress || updateInProgress
                              ? 'Loading...'
                              : 'Decline'
                          }
                          tabIndex={-1}
                          onClick={() =>
                            onUpdateStatus(CofApprovalStatus.DECLINED)
                          }
                        />
                      </div>
                    )}
                </div>
              </div>
            )}
        </div>
      )}
      {collapsed && (
        <div className={cn.companyOfficialWrapper}>
          <div className={cn.companyOfficialApplication}>
            <div className={cn.companyOfficialApplicationLeft}>
              <div className={cn.companyOfficialApplicationTitle}>
                Customer Application:
              </div>
              <div
                className={`${
                  cn.companyOfficialApplicationStatus
                } ${statusClassName} ${
                  companyOfficial?.subApplication.reviewStatus ===
                  ReviewStatus.HAS_DUPLICATE
                    ? cn.declinedStatus
                    : ''
                }`}
              >
                {cofApplicationStatus}
              </div>
            </div>
            <div className={cn.companyOfficialApplicationRight}>
              <div className={cn.linkButtonWrapper}>
                {/* <NavLink
                  type="button"
                  className={`${cn.copyLinkButton} ${
                    copyEffect ? cn.copied : ''
                  }`}
                  to={`${generatePath(ROUTES.SUMSUB, {
                    applicationId: companyOfficial?.subApplication.id as string,
                  })}?phone=${companyOfficial?.subApplication.phone}${
                    companyOfficial?.subApplication.email
                      ? `&email=${companyOfficial?.subApplication.email}`
                      : ''
                  }`}
                  onClick={onCopy}
                  target="_blank"
                >
                  <div className={cn.copyLinkContent}>
                    <IconLink />
                  </div>
                  <div className={cn.copyLinkContent}>Copy link to CDD</div>
                </NavLink> */}
              </div>
              {auditLogAvailable && value.id && (
                <div className={cn.cofChangeLogLinkWrapper}>
                  <NavLink
                    to={`/administration/change-logs?entityType=APPLICATION_TO_APPLICATION&entityId=${companyOfficial?.id}`}
                    className={cn.cofChangeLogLink}
                    target="_blank"
                  >
                    <IconChangeLoClock />
                    Change Log
                  </NavLink>
                </div>
              )}
              {companyOfficial &&
                (companyOfficial?.subApplication.status !==
                  NewApplicationStatus.ACCEPTED ||
                  (companyOfficial?.subApplication.status ===
                    NewApplicationStatus.ACCEPTED &&
                    companyOfficial?.subApplication?.organizationId)) && (
                  <div className={cn.applicationLinkWrapper}>
                    <NavLink
                      to={cofLink as string}
                      className={cn.applicationLink}
                      target="_blank"
                      tabIndex={-1}
                    >
                      {companyOfficial?.subApplication.status !==
                      NewApplicationStatus.ACCEPTED
                        ? 'Go to application'
                        : 'Go to customer'}
                    </NavLink>
                  </div>
                )}
            </div>
          </div>
          <InfoRow title="Position">
            <InputText
              name={`position-${index}`}
              placeholder="Enter position..."
              value={companyOfficialPosition}
              onChange={onChange}
              size={InputSize.SMALL}
              className="borderless"
              tabIndex={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
                  ? -1
                  : 0
              }
              disabled={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
              }
            />
          </InfoRow>
          <InfoRow title="Signature Type">
            <Select
              list={[
                {
                  name: 'None',
                  value: SignatureType.NONE,
                },
                {
                  name: 'Single',
                  value: SignatureType.SINGLE,
                },
              ]}
              name={`signatureType-${index}`}
              value={companyOfficialSignatureType}
              placeholder="Select Signature type"
              onChange={onChange}
              size={SelectSize.SMALL}
              tabIndex={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
                  ? -1
                  : 0
              }
              disabled={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
              }
              borderless
            />
          </InfoRow>
          <InfoRow title="Access Right">
            <Select
              list={[
                {
                  name: 'Viewer',
                  value: AccessRight.VIEWER,
                },
                {
                  name: 'None',
                  value: AccessRight.NONE,
                },
              ]}
              name={`accessRight-${index}`}
              value={companyOfficialAccessRight}
              placeholder="Select Access Right"
              onChange={onChange}
              size={SelectSize.SMALL}
              tabIndex={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
                  ? -1
                  : 0
              }
              disabled={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
              }
              borderless
            />
          </InfoRow>
          <div className={cn.havingControlChekboxWrapper}>
            <Checkbox
              type="checkbox"
              name={`havingControl-${index}`}
              checked={havingControl}
              title="Having a control in company"
              onChange={(e) => setHavingControl(e.target.checked)}
              tabIndex={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
                  ? -1
                  : 0
              }
              disabled={
                !applicationId ||
                disabled ||
                value.status === NewApplicationStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
              }
            />
          </div>
          {havingControl && (
            <>
              {error && <div className={cn.companyOfficialError}>{error}</div>}
              <InfoRow title="Percentage of control">
                <InputText
                  name={`percentage-${index}`}
                  placeholder="Enter percentage of control..."
                  value={companyOfficialPercentage}
                  onChange={onChange}
                  size={InputSize.SMALL}
                  className="borderless"
                  tabIndex={
                    !applicationId ||
                    disabled ||
                    value.status === NewApplicationStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                    !activePermissions?.includes(
                      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !applicationId ||
                    disabled ||
                    value.status === NewApplicationStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                    !activePermissions?.includes(
                      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                    )
                  }
                />
              </InfoRow>
              <InfoRow title="Nature of control">
                <Select
                  list={[
                    {
                      name: 'Direct Control',
                      value: NatureOfControlEnum.DIRECT_CONTROL,
                    },
                    {
                      name: 'Indirect Control',
                      value: NatureOfControlEnum.INDIRECT_CONTROL,
                    },
                  ]}
                  name={`natureOfControl-${index}`}
                  value={companyOfficialNatureOfControl}
                  placeholder="Select Nature of Control"
                  onChange={onChange}
                  size={SelectSize.SMALL}
                  tabIndex={
                    !applicationId ||
                    disabled ||
                    value.status === NewApplicationStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                    !activePermissions?.includes(
                      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                    )
                      ? -1
                      : 0
                  }
                  disabled={
                    !applicationId ||
                    disabled ||
                    value.status === NewApplicationStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.DECLINED ||
                    companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                    !activePermissions?.includes(
                      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                    )
                  }
                  borderless
                />
              </InfoRow>
            </>
          )}
          <div className={cn.companyOfficialControls}>
            <button
              type="button"
              className={cn.companyOfficialUpdateButton}
              onClick={onUpdate}
              disabled={
                disabled ||
                !value.position ||
                companyOfficial?.status === CofApprovalStatus.DECLINED ||
                companyOfficial?.status === CofApprovalStatus.ACCEPTED ||
                !activePermissions?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_EDIT_DETAILS_ACTION,
                )
              }
              tabIndex={-1}
            >
              {updateInProgress ? 'Loading...' : 'Save settings'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyOfficial;
